import React from 'react';
import './TxnDrawer.css';
import { Link } from 'react-router-dom';

export default function TxnDrawer({ onClose, username, currentUser, transactionId }) {
  return (
    <div className="txn-drawer-backdrop" onClick={onClose}>
      <div className="txn-drawer-content" onClick={(e) => e.stopPropagation()}>
        <div className="txn-header">
          <span>Verified Payment</span>
          <button className="txn-close" onClick={onClose}>✕</button>
        </div>

        <div className="txn-body">
          <h4>✅ This post is verified</h4>
          <p className="txn-popup-text">
            This post is linked to a completed transaction using <strong>Pi coins</strong> in the BarterFi marketplace.
            <br />
            <strong>{username}</strong> {currentUser === username ? 'made a payment' : 'received a payment'}.
            <br />
            <strong>Transaction ID:</strong> {transactionId}
            <br />
            You can view this transaction in the{' '}
            <Link to="/receipts" className="receipt-link" onClick={onClose}>
              Public Receipt Log
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
